import { useIntl } from 'react-intl'

import { QueuesAPI } from '@api/queuesAPI'

import { Option } from '@models/option'

import { AsyncSelectField, AsyncSelectFieldProps } from '@components/Form/AsyncSelect/AsyncSelectField'

type Props<IsMulti extends boolean> = Omit<AsyncSelectFieldProps<IsMulti>, 'onSearch'> & {
  defaultValue?: Option
}

const QueueListSelectField = <IsMulti extends boolean = false>({ defaultValue, ...props }: Props<IsMulti>) => {
  const intl = useIntl()

  const searchDebounce = async (): Promise<Array<Option>> => {
    const response = await QueuesAPI.getOptionsForQueueCounterCheckInForm()

    if (!response.data?.nodes) return []

    return response.data?.nodes!.map(
      (counter) =>
        new Option({
          label: counter.name!,
          value: counter.id!,
          data: {
            id: counter.id,
          },
        })
    )
  }

  return (
    <AsyncSelectField
      {...props}
      isSearchable={false}
      onSearch={searchDebounce}
      noOptionsMessage={() => intl.formatMessage({ id: 'queue.not_found' })}
      defaultValue={defaultValue}
    />
  )
}

export { QueueListSelectField }
